import React from 'react'
import GalleryListPageComponent from './GalleryListPageComponent'

const GalleryListPage = () => {
  return (
    <div>
      <GalleryListPageComponent/>
    </div>
  )
}

export default GalleryListPage
